import { createProductionTypeService } from './ProductionTypeService.impl';

export const myProductionTypeService = createProductionTypeService();
